<template>
  <div>
    <h1>Warehouse Behavior</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Incoming Pattern By Day</h5>
      <incoming-pattern-by-day
        :filterUrl="filterUrl"
        :type="'incoming'"
      ></incoming-pattern-by-day>
    </div>
    <!-- Registered By Category End -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Incoming Pattern By Hour</h5>
      <incoming-pattern-by-hour
        :filterUrl="filterUrl"
        :type="'incoming'"
      ></incoming-pattern-by-hour>
    </div>
    <!-- Registered By Category End -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Incoming Pattern By Date</h5>
      <incoming-pattern-by-date
        :filterUrl="filterUrl"
        :type="'incoming'"
      ></incoming-pattern-by-date>
    </div>
    <!-- Registered By Category End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import incomingPatternByDay from './children/incomingPatternByDay'
  import incomingPatternByHour from './children/incomingPatternByHour'
  import incomingPatternByDate from './children/incomingPatternByDate'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      incomingPatternByDay,
      incomingPatternByHour,
      incomingPatternByDate,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>